import { type ReactElement } from 'react';
import { Link } from 'react-router';
import { recipePath } from '../lib/paths';
import { MinusIcon } from './icons';
import { type RecipeMatch } from '../types';

interface MatchRowProps {
	match: RecipeMatch & { missingIngredients?: string[] };
}

/**
 * One recipe against the pantry, as the design system's "Cookable now" panel
 * draws it: the name, then either "nothing to buy" or the shortfall in the
 * spot ink, and the coverage as a mono fraction on the right — never a bar,
 * never a percentage, never a badge.
 */
function MatchRow({ match }: MatchRowProps): ReactElement {
	const missing = match.missingIngredients ?? [];

	return (
		<Link className='res' to={recipePath(match)}>
			<span>
				<span className='res__name title'>{match.name}</span>
				{match.missingCount === 0 ? (
					<span className='res__meta caption'>Nothing to buy</span>
				) : (
					<span className='gapline caption'>
						<MinusIcon />
						{missing.length > 0
							? `missing ${missing.join(', ')}`
							: `missing ${match.missingCount} ${match.missingCount === 1 ? 'ingredient' : 'ingredients'}`}
					</span>
				)}
			</span>
			<span className='figure'>
				<span aria-hidden='true'>{match.matches}/{match.totalIngredients}</span>
				<span className='sr-only'>{`${match.matches} of ${match.totalIngredients} ingredients in your pantry`}</span>
			</span>
		</Link>
	);
}

export default MatchRow;
